<!-- <a href="#" target="_blank" class="logo"></a> -->
<div class="logo">
  <img src="assets/img/RT-Verge.png" alt="" class="logo-img">
</div>

